<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat>
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Public Equities</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>
  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    fixed-header
    :headers="headers"
    :items="confirmedEquities ? allequities : allequities.filter(a => a.CheckerID === 0)"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-dialog persistent v-model="rejectionDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                ok
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialog" max-width="350px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                yes
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Equity</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
          <v-col>
            <v-checkbox
              v-model="equity.IsDeListed"
              label="Delisted?"
              class="ma-0 pa-0"
              @change="equity.IsBlocked = equity.IsDeListed || equity.IsSuspended"
            ></v-checkbox>
            <v-text-field
              dense filled
              color="#2A353D"
              v-model="equity.CounterSymbol"
              label="Symbol"
              required
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 15) || 'field must be less than 15 characters'
              ]"
            ></v-text-field>
            <v-select
              filled dense
              v-model="equity.SectorID"
              :items="allSectors.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="SectorName"
              item-value="SectorID"
              label="Sector"
              placeholder="----"
            ></v-select>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="PriceDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="PriceDate"
                  label="Price Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense filled color="#2A353D"
                  :error-messages="errors"
                  :rules="TextFieldRules"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker color="#2A353D" v-model="PriceDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(PriceDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="equity.IsSuspended"
              label="Suspended?"
              class="ma-0 pa-0"
              @change="equity.IsBlocked = equity.IsDeListed || equity.IsSuspended"
            ></v-checkbox>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="equity.EquityCode"
              label="Equity Code"
              required
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 12) || 'field must be less than 12 characters'
              ]"
            ></v-text-field>
            <v-select
              filled dense
              :items="allCounterparties.filter(a => a.IsTransferSecretary == true && a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="CounterPartyName"
              item-value="CounterPartyID"
              v-model="equity.TransferSecretaryID"
              label="Transfer Secretary"
              placeholder="----"
            ></v-select>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="equity.SharePrice"
              label="Share Price"
              required
              type="number"
              placeholder="----"
              :rules="TextFieldRules"
            ></v-text-field>
            <v-select
              filled dense
              v-model="equity.StockExchangeId"
              :items="allStockExchanges.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="ExchangeName"
              item-value="StockExchangeId"
              label="Stock Exchange"
              placeholder="----"
            ></v-select>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="equity.MultipleListings"
              label="Multiple Listings?"
              class="ma-0 pa-0"
            ></v-checkbox>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="equity.EquityName"
              label="Equity Name"
              required
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 100) || 'field must be less than 100 characters'
              ]"
            ></v-text-field>
            <v-text-field
              dense filled
              color="#2A353D"
              v-model="equity.ISINCode"
              label="ISIN Code"
              required
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 12) || 'field must be less than 12 characters'
              ]"
            ></v-text-field>
            <v-text-field
              :disabled="!equity.IsBlocked"
              light dense filled
              color="#2A353D"
              v-model="equity.ReasonBlocked"
              label="Reason for Suspension/Delisting"
              required
              placeholder="----"
              :rules="[
                v => v ? (v && v.length <= 250) || 'field must be less than 250 characters' : null
              ]"
            ></v-text-field>
            <div class="text-right mt-7">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="createNew()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                submit
              </v-btn>          
            </div>
          </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="d-flex flex-row grey--text subtitle-1 font-weight-normal">Equity: {{currentEquity.EquityCode.toUpperCase()}}</v-toolbar-title>
            <v-spacer/>
            <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentEquity.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span v-if="currentEquity.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentEquity.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentEquity.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
          <v-col>
            <v-checkbox
              v-model="currentEquity.IsDeListed"
              label="Delisted?"
              class="ma-0 pa-0"
              @change="currentEquity.IsBlocked = currentEquity.IsDeListed || currentEquity.IsSuspended"
            ></v-checkbox>
            <v-text-field
              dense filled
              color="#2A353D"
              v-model="currentEquity.CounterSymbol"
              label="Symbol"
              :readonly="view"
              required
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 15) || 'field must be less than 15 characters'
              ]"
            ></v-text-field>
            <v-select
              filled dense
              v-model="currentEquity.SectorID"
              :items="allSectors.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="SectorName"
              item-value="SectorID"
              :readonly="view"
              label="Sector"
              placeholder="----"
            ></v-select>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="PriceDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="PriceDate"
                  label="Price Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  :disabled="view"
                  dense filled color="#2A353D"
                  :error-messages="errors"
                  :rules="TextFieldRules"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker color="#2A353D" v-model="PriceDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(PriceDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="currentEquity.IsSuspended"
              label="Suspended?"
              class="ma-0 pa-0"
              @change="currentEquity.IsBlocked = currentEquity.IsDeListed || currentEquity.IsSuspended"
            ></v-checkbox>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="currentEquity.EquityCode"
              label="Equity Code"
              :readonly="view"
              required
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 12) || 'field must be less than 12 characters'
              ]"
            ></v-text-field>
            <v-select
              filled dense
              v-model="currentEquity.TransferSecretaryID"
              :items="allCounterparties.filter(a => a.IsTransferSecretary == true && a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="CounterPartyName"
              item-value="CounterPartyID"
              label="Transfer Secretary"
              placeholder="----"
              :readonly="view"
            ></v-select>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="currentEquity.SharePrice"
              label="Share Price"
              required
              type="number"
              :readonly="view"
              placeholder="----"
              :rules="TextFieldRules"
            ></v-text-field>
            <v-select
              filled dense
              v-model="currentEquity.StockExchangeId"
              :items="allStockExchanges.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="ExchangeName"
              item-value="StockExchangeId"
              label="Stock Exchange"
              placeholder="----"
              :readonly="view"
            ></v-select>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="currentEquity.MultipleListings"
              label="Multiple Listings?"
              :readonly="view"
              class="ma-0 pa-0"
            ></v-checkbox>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="currentEquity.EquityName"
              label="Equity Name"
              required
              :readonly="view"
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 100) || 'field must be less than 100 characters'
              ]"
            ></v-text-field>
            <v-text-field
              dense filled
              color="#2A353D"
              v-model="currentEquity.ISINCode"
              label="ISIN Code"
              :readonly="view"
              required
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 12) || 'field must be less than 12 characters'
              ]"
            ></v-text-field>
            <v-text-field
              :disabled="!currentEquity.IsBlocked"
              light dense filled
              color="#2A353D"
              v-model="currentEquity.ReasonBlocked"
              label="Reason for Suspension/Delisting"
              required
              :readonly="view"
              placeholder="----"
              :rules="[
                v => v ? (v && v.length <= 250) || 'field must be less than 250 characters' : null
              ]"
            ></v-text-field>
            <div class="text-right mt-7">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              <v-btn class="white--text mr-3" v-if="!view" small color="#2A353D" @click="update()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                save
              </v-btn>          
            </div>   
          </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>
      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedEquities" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedEquities" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Public Equities.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Public Equities.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-if="confirmedEquities" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedEquities" @click="confirmedEquities = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedEquities && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveEquity(item, index); updateStatus()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedEquities && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveEquity(item, index); rejectionDialog = true"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedEquities"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveEquity(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        :disabled="edit"
        @click="view = true; setActiveEquity(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-icon
        :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
        color="#2A353D" @click="setActiveEquity(item, index); deleteDialog = true"
      >
       mdi-trash-can-outline
      </v-icon>
    </template>

    <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import dealingService from '../services/dealing.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      confirmedEquities: true,
      edit: false,
      create: false,
      view: false,
      loading: false,
      rejectionDialog: false,
      deleteDialog: false,
      permitted: null,
      permitted_dialog: true,
      RejectionStatus: 0,
      PriceDate: '',
      message: '',
      search: '',
      valid: true,
      currentEquity: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Symbol',
          align: 'start',
          sortable: true,
          value: 'CounterSymbol'
        },
        { text: 'Equity Code', value: 'EquityCode', sortable: false },
        { text: 'Equity', value: 'EquityName', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      equity: {},
      submitted: false,
      errors: [],
    }
  },

  computed: {
    ...mapGetters([
      "allequities",
      "allSectors",
      "allStockExchanges",
      "allRejectionReasons",
      "allUsers",
      "allCounterparties",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 303).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 303).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 303).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 303).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 303).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {
    PriceDate: function(newValue) {
      if(newValue != null && newValue != ''){
        var data = {
          Date: newValue,
        };

        dealingService.checkIsWeekendHoliday(data)
        .then(response => {
          this.errors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
        })
      }
    },
    'currentEquity.EquityID': {
      handler: function() {
        this.PriceDate = this.currentEquity.PriceDate;
      },
      deep: true
    }
  },

  methods: {
    ...mapActions([
      "createEquity",
      "updateEquity",
      "deleteEquity"
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.loading = true;
        this.equity.PriceDate = this.PriceDate,
        this.equity.MakerID = this.currentUser.SecurityUserID,
        this.equity.CheckerID = this.CheckerID,
        this.equity.LastUserID = this.currentUser.SecurityUserID,
        this.createEquity(this.equity)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newEquity',
            data: response.data
          });
          this.message = response.data.message
          this.loading = false;
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })        
      }
    },

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.loading = true;
        if(this.currentEquity.CheckerID == 0){
          this.currentEquity.LastUserID = this.currentUser.SecurityUserID,
          this.currentEquity.RejectionID = this.RejectionStatus,
          this.currentEquity.CheckerID = 0,
          this.currentEquity.CheckDate = null,

          this.updateEquity(this.currentEquity)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updEquity',
              data: this.currentEquity
            });
            
            this.message = response.data.message
            this.loading = false;
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          })
        } else {
          this.currentEquity.MakerID = this.currentUser.SecurityUserID
          this.currentEquity.LastUserID = this.currentUser.SecurityUserID,
          this.currentEquity.RejectionID = this.RejectionStatus,
          this.currentEquity.CheckerID = 0,
          this.currentEquity.CheckDate = null,
          this.currentEquity.MakeDate = new Date(),

          this.updateEquity(this.currentEquity)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updEquity',
              data: this.currentEquity
            });
            
            this.message = response.data.message
            this.loading = false;
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          })
        }
      }
    },

    deleteItem() {
      this.message = '';
      this.loading = true;

      this.deleteEquity(this.currentEquity)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltEquity',
          data: this.currentEquity
        });
        
        this.message = response.data.message
        this.loading = false;
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
      })
    },

    updateStatus() {
      this.message = '';
      this.loading = true;

      this.currentEquity.CheckerID = this.currentUser.SecurityUserID,
      this.currentEquity.LastUserID = this.currentUser.SecurityUserID,
      this.currentEquity.RejectionID = this.RejectionStatus,
      this.currentEquity.CheckDate = new Date(),
      this.currentEquity.updatedAt = new Date(),

      this.updateEquity(this.currentEquity)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updEquity',
          data: this.currentEquity
        });
        
        this.message = response.data.message
        this.loading = false;
        this.RejectionStatus = 0;
        this.rejectionDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
        this.RejectionStatus = 0;
        this.rejectionDialog = false
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Public Equities", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Public Equities.pdf')
      }
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedEquities = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false;
      this.PriceDate = ''
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.PriceDate = '';
      this.equity = {};
      this.create = false
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveEquity (item, index) {
      this.currentEquity = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isListedEquities().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedEquities", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
